import React from 'react';
import styles from './TopStripForEthos.module.css';

const features = [
  {
    id: 1,
    icon: '/static/icons/landingPage/payment.png',
    text: 'Secure Payment',
    alt: 'Secure Payment Icon'
  },
  {
    id: 2,
    icon: '/static/icons/landingPage/satisfaction.png',
    text: 'Satisfaction Guaranteed',
    alt: 'Satisfaction Guaranteed Icon'
  },
  {
    id: 3,
    icon: '/static/icons/landingPage/cirtified.png',
    text: 'Certified Sellers',
    alt: 'Certified Sellers Icon'
  }
];

export const TopStrip = () => {
  return (
    <div className={styles.topStrip}>
      <div className={styles.stripBlock}>
      {features.map((feature, index) => (
        <React.Fragment key={feature.id}>
          <span className={styles.item}>
            <img 
              src={feature.icon} 
              alt={feature.alt} 
              className={styles.icon} 
              loading="lazy"
            />
            {feature.text}
          </span>
        </React.Fragment>
       
      ))}
      </div>
    </div>
  );
};

export default TopStrip;
